<template>
	<a-tabs default-active-key="1" @change="callback">
		<a-tab-pane key="1" tab="耗材出库">
			<div class="content_main" id="content_main">
				<div style="margin-top: 10px">
					<a-button type="primary" v-if="warehouseConsumables" @click="modification"
						:disabled="selectedRowKeysTabItems.length < 1" style="margin-right: 5px">
						直接出库
					</a-button>
					<a-button type="primary" @click="claim" :disabled="selectedRowKeysTabItems.length < 1"
						style="margin-right: 5px">
						直接领用
					</a-button>
				</div>
				<div class="content_main_top">
					<a-select class="a_input_self margin_self" allowClear placeholder="请选择公司" v-model="company_id"
						@change="changge()">
						<a-select-option :value="item.deptId" v-for="(item, index) in companyData" :key="index">
							{{ item.title }}
						</a-select-option>
					</a-select>
					<a-input v-model="spuSn" allowClear class="a_input_self margin_self" placeholder="品类编号"
						@keyup.enter.native="query2" />
					<a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="品类名称"
						@keyup.enter.native="query2" />
					<a-button type="primary" @click="query2" style="margin-left: 10px"> 查询 </a-button>
					<a-button type="primary" ghost @click="result"> 清空 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll">
					<a-table :columns="columnslist" :data-source="data" :scroll="{ y: scroll_y }" bordered
						:pagination="pagination" @change="changeTable" rowKey="id"
						:row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChange }">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
						</span>
						<!-- asset_type -->
						<span slot="asset_type" slot-scope="text">
							{{ text? operTypeMap[text].text : '' }}
						</span>
						<span slot="dept_id" slot-scope="text">
							{{ text? deptMap[text].text : '' }}
						</span>
						<span slot="is_inspected" slot-scope="text">
							{{ instrumentMap[text] }}
						</span>
						<!-- <span slot="action" slot-scope="text, record">
							<a @click="get_sku(record)">批次</a>
						</span> -->
					</a-table>
				</div>
				<a-modal title="耗材-详情" :visible="detailsvisible" @ok="detailsOk" @cancel="detailsCancel" width="880px">
					<template slot="footer">
						<a-button type="primary" @click="detailsOk"> 确定 </a-button>
					</template>
					<a-form-model :model="detailsrow" style="height: 500px">
						<a-form-model-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.company_name }}</span>
						</a-form-model-item>
						<a-form-model-item label="物品状态" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.state ? statusMap[detailsrow.state] : '' }}</span>
						</a-form-model-item>
						<a-form-model-item label="物品名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.name }}</span>
						</a-form-model-item>
						<a-form-model-item label="采购时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.purchase_time }}</span>
						</a-form-model-item>
						<a-form-model-item label="是否检定" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{
								detailsrow.is_inspected == null ? '' : instrumentMap[detailsrow.is_instrument]
							}}</span>
						</a-form-model-item>
						<a-form-model-item label="采购价格" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.purchase_price }}</span>
						</a-form-model-item>
						<a-form-model-item label="物品编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.spu_sn }}</span>
						</a-form-model-item>
						<a-form-model-item label="供应商" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.dealer }}</span>
						</a-form-model-item>
						<a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.model }}</span>
						</a-form-model-item>
						<a-form-model-item label="负责部门" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].text : '' }}</span>
						</a-form-model-item>
						<a-form-model-item label="责任人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.charger }}</span>
						</a-form-model-item>
						<a-form-model-item label="入库数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.amount }}</span>
						</a-form-model-item>
						<a-form-model-item label="入库人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.operator }}</span>
						</a-form-model-item>
						<a-form-model-item label="准用说明" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.permit }}</span>
						</a-form-model-item>
						<a-form-model-item label="保管人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
							<span>{{ detailsrow.keeper }}</span>
						</a-form-model-item>
						<a-form-model-item label="最后检定时间" :labelCol="labelCol" :wrapperCol="wrapperCol"
							class="form_item" v-if="detailsrow.is_instrument">
							<span>{{ detailsrow.inspect_time }}</span>
						</a-form-model-item>
						<a-form-model-item label="检定结果" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item"
							v-if="detailsrow.is_instrument">
							<span>{{ detailsrow.inspect_result }}</span>
						</a-form-model-item>
						<a-form-model-item label="精度" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item"
							v-if="detailsrow.is_instrument">
							<span>{{ detailsrow.precisions }}</span>
						</a-form-model-item>
					</a-form-model>
				</a-modal>
				<a-modal v-model="changevisible" title="耗材-直接出库" width="80%" :maskClosable="false">
					<template slot="footer">
						<a-button key="back" @click="moneyCancel"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="moneyOk"> 出库 </a-button>
					</template>
					<a-table :data-source="selectedRow" bordered :pagination="false">
						<a-table-column key="name" title="物品名称" data-index="name" />
						<a-table-column key="model" title="规格型号" data-index="model" />
						<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected">
							<template slot-scope="text">
								{{ instrumentMap[text] }}
							</template>
						</a-table-column>
						<a-table-column key="operator" title="出库人" data-index="operator">
							<template slot-scope="text">
								{{ username }}
							</template>
						</a-table-column>
						<a-table-column key="amount" title="物品数量" data-index="amount">
							<template slot-scope="text, record">
								{{ record.amount }}
							</template>
						</a-table-column>
						<a-table-column key="dept_id" title="领用部门" data-index="dept_id">
							<template slot-scope="text, record">
								<a-tree-select allowClear :treeData="deptTree" placeholder="请选择"
									v-model="record.dept_id" @change="leaderid($event)" style="width: 200px;"
									treeDefaultExpandAll>
								</a-tree-select>
								<!-- <a-select allowClear placeholder="负责部门" @change="leaderid($event)" v-model="record.dept_id" style="width: 200px;">
									<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
										{{ item.dept_name }}
									</a-select-option>
								</a-select> -->
							</template>
						</a-table-column>
						<a-table-column key="applier" title="领用人" data-index="applier">
							<template slot-scope="text, record">
								<a-select show-search allowClear placeholder="领用人" class="margin_self"
									v-model="record.applier" @change="changeapplier" style="width: 120px">
									<a-select-option :value="item.userName" v-for="(item, index) in plainOptions"
										:key="index">
										{{ item.userName }}
									</a-select-option>
								</a-select>
							</template>
						</a-table-column>
						<a-table-column key="outnumber" title="领用数量" data-index="outnumber">
							<template slot-scope="text, record">
								<a-input @blur="outchange(record)" type="number" v-model="record.outnumber" />
							</template>
						</a-table-column>
						<a-table-column key="unit" title="单位" data-index="unit" />
						<a-table-column key="action" title="操作" data-index="action" width="150px">
							<template scope="text,record,index">
								<a @click="addTo(record)">添加</a>
								<a-divider type="vertical" />
								<a @click="removeTo(index, record)">删除</a>
							</template>
						</a-table-column>
					</a-table>
				</a-modal>
				<a-modal v-model="claimvisible" title="耗材-直接领用" width="60%" :maskClosable="false">
					<template slot="footer">
						<a-button key="back" @click="claimCancel"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="claimOk"> 领用 </a-button>
					</template>
					<a-table :data-source="selectedRow" bordered :pagination="false">
						<a-table-column key="name" title="物品名称" data-index="name" />
						<a-table-column key="model" title="规格型号" data-index="model" />
						<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected">
							<template slot-scope="text">
								{{ instrumentMap[text] }}
							</template>
						</a-table-column>
						<a-table-column key="operator" title="领用人" data-index="operator">
							<template slot-scope="text">
								{{ username }}
							</template>
						</a-table-column>
						<a-table-column key="amount" title="物品数量" data-index="amount">
							<template slot-scope="text, record">
								{{ record.amount }}
							</template>
						</a-table-column>
						<!-- <a-table-column key="dept_id" title="领用部门" data-index="dept_id">
							<template slot-scope="text, record">
								<a-select allowClear placeholder="负责部门" @change="leaderid($event)" v-model="record.dept_id" style="width: 200px;">
									<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
										{{ item.dept_name }}
									</a-select-option>
								</a-select>
							</template>
						</a-table-column>
						<a-table-column key="applier" title="领用人" data-index="applier">
							<template slot-scope="text, record">
								<a-select show-search allowClear placeholder="领用人" class="margin_self" v-model="record.applier" @change="changeapplier"
								 style="width: 120px">
									<a-select-option :value="item.userName" v-for="(item, index) in plainOptions" :key="index">
										{{ item.userName }}
									</a-select-option>
								</a-select>
							</template>
						</a-table-column> -->
						<a-table-column key="outnumber" title="领用数量" data-index="outnumber">
							<template slot-scope="text, record">
								<a-input @blur="outchange(record)" type="number" v-model="record.outnumber" />
							</template>
						</a-table-column>
						<a-table-column key="unit" title="单位" data-index="unit" />
					</a-table>
				</a-modal>
				<!-- <a-modal v-model="skuvisible" title="耗材批次" width="80%" @ok="skuOk">
					<div style="margin: 10px;">
						<a-input v-model="skuSerch.name" allowClear class="a_input_self margin_self"
							placeholder="物品名称" />
						<a-range-picker valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 220px" allowClear
							v-model="skuSerch.time" :placeholder="['开始日期', '结束日期']" />
						<a-button type="primary" @click="serch_sku" style="margin-left: 10px"> 查询 </a-button>
						<a-button type="primary" @click="exp2"> 导出 </a-button>
					</div>
					<a-table :columns="columns" :data-source="skudata" width="100%" bordered :pagination="skuSerch"
						@change="handleTableChange">
						<span slot="dept_id" slot-scope="text">
							{{ text ? deptMap[text].text : '' }}
						</span>
						<span slot="action" slot-scope="text, record">
							<a @click="details(record)">详情</a>
						</span>
					</a-table>
				</a-modal> -->
			</div>
		</a-tab-pane>
		<a-tab-pane key="2" tab="库管领用确认" v-if="bizListConsumables">
			<div class="content_main" id="content_main">
				<div style="margin-top: 10px">
					<a-button type="primary" @click="confirmation" style="margin-right: 5px"
						:disabled="selectedRowKeysTabItems.length < 1">
						领用确认
					</a-button>
					<a-button type="primary" @click="reject" style="margin-right: 5px"
						:disabled="selectedRowKeysTabItems.length < 1">
						驳回
					</a-button>
				</div>
				<div class="content_main_top">
					<a-input v-model="querynum.spuSn" allowClear class="a_input_self margin_self" placeholder="品类编号"
						@keyup.enter.native="queryclaim" />
					<a-input v-model="querynum.name" allowClear class="a_input_self margin_self" placeholder="品类名称"
						@keyup.enter.native="queryclaim" />
					<a-input v-model="querynum.createByName" allowClear class="a_input_self margin_self"
						placeholder="领用人" @keyup.enter.native="queryclaim" />
					<a-button type="primary" @click="queryclaim" style="margin-left: 10px" v-if="bizListConsumables"> 查询
					</a-button>
					<a-button type="primary" ghost @click="queryall"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll">
					<a-table :columns="columnsclaim" :data-source="dataclaim" :scroll="{ y: scroll_y }" bordered
						:pagination="pagination2" @change="changeTableclaim" rowKey="id"
						:row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChange }">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination2.current - 1) * pagination2.pageSize + index + 1 }}
						</span>
						<span slot="isInspected" slot-scope="text">
							{{ instrumentMap[text] }}
						</span>
					</a-table>
				</div>
			</div>
		</a-tab-pane>
		<a-tab-pane key="3" tab="个人领用记录">
			<div class="content_main" id="content_main">
				<div class="content_main_top">
					<a-input v-model="querynum2.name" allowClear class="a_input_self margin_self" placeholder="品类名称"
						@keyup.enter.native="queryclaim2" />
					<a-input v-model="querynum2.spuSn" allowClear class="a_input_self margin_self" placeholder="品类编号"
						@keyup.enter.native="queryclaim2" />
					<a-button type="primary" @click="queryclaim2" style="margin-left: 10px"> 查询 </a-button>
					<a-button type="primary" ghost @click="queryall2"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll">
					<a-table :columns="columnsclaim2" :data-source="dataclaim2" :scroll="{ y: scroll_y }" bordered
						:pagination="pagination3" @change="changeTableclaim2">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination3.current - 1) * pagination3.pageSize + index + 1 }}
						</span>
						<span slot="isInspected" slot-scope="text">
							{{ instrumentMap[text] }}
						</span>
						<span slot="status" slot-scope="text"
							:style="{ color: text == 1 ? 'green' : text == 2 ? 'red' : '#1890ff' }">
							{{ receive[text] }}
						</span>
					</a-table>
				</div>
			</div>
		</a-tab-pane>
	</a-tabs>
</template>

<script>
import { tree_all, enableParent } from '@/api/purchase'
import debounce from 'lodash/debounce'
import {
	// get_dept_tree,
	dict,
	get_spu_xlsx,
	biz_claim_save,
	biz_claim_list,
	biz_claim_update,
	biz_claim_listByUser,
	biz_claim_updateReject,
	consumablesList,
	consumablesSku,
	consumablesSkuOut
} from '@/api/assetmenag'
import {
	getDeptListEnable2
} from '@/api/system'
import storage from 'store'
import {
	ACCESS_TOKEN
} from '@/store/mutation-types'
import {
	get_users2,
	get_dict
} from '@/utils/unit_axios'
import {
	checkPermission
} from '@/utils/permissions'
const columns = [{
	title: '公司名称',
	dataIndex: 'company_name',
	ellipsis: true,
},
{
	title: '物品名称',
	dataIndex: 'name',
	key: 'name',
	ellipsis: true,
},
{
	title: '规格型号',
	dataIndex: 'model',
	key: 'model',
	ellipsis: true,
},
{
	title: '物品数量',
	dataIndex: 'amount',
	key: 'amount',
	ellipsis: true,
},
{
	title: '采购时间',
	dataIndex: 'purchase_time',
	key: 'purchase_time',
	ellipsis: true,
},
{
	title: '采购价格',
	dataIndex: 'purchase_price',
	key: 'purchase_price',
	ellipsis: true,
},
{
	title: '物品单价',
	dataIndex: 'price',
	key: 'price',
	ellipsis: true,
},
{
	title: '供应商',
	dataIndex: 'dealer',
	key: 'dealer',
	ellipsis: true,
},
{
	title: '保管人',
	dataIndex: 'keeper',
	key: 'keeper',
	ellipsis: true,
},
{
	title: '责任人',
	dataIndex: 'charger',
	key: 'charger',
	ellipsis: true,
},
{
	title: '责任部门',
	dataIndex: 'dept_id',
	scopedSlots: {
		customRender: 'dept_id',
	},
	ellipsis: true,
},
{
	title: '操作',
	key: 'action',
	scopedSlots: {
		customRender: 'action',
	},
	width: 150,
},
]
const columnsclaim = [{
	title: '序号',
	dataIndex: 'index',
	key: 'index',
	scopedSlots: {
		customRender: 'index',
	},
	width: 70,
	ellipsis: true,
},
//  {
// 	title: '物品编码',
// 	dataIndex: 'spuSn',
// 	ellipsis: true,
// },

{
	title: '公司名称',
	dataIndex: 'companyName',
	ellipsis: true,
},
{
	title: '类别',
	dataIndex: 'spuTypeName',
	ellipsis: true,
},
{
	title: '品类编号',
	dataIndex: 'spuSn',
	ellipsis: true,
},
// {
// 	title: '资产分类',
// 	dataIndex: 'spuTypeName',
// 	ellipsis: true,
// },
{
	title: '品类名称',
	dataIndex: 'name',
	ellipsis: true,
},
{
	title: '规格型号',
	dataIndex: 'model',
	ellipsis: true,
},
{
	title: '是否已检定',
	dataIndex: 'isInspected',
	key: 'isInspected',
	scopedSlots: {
		customRender: 'isInspected',
	},
	ellipsis: true,
},
{
	title: '采购均价',
	dataIndex: 'price',
	ellipsis: true,
},
// {
// 	title: '物品名称',
// 	dataIndex: 'name',
// 	ellipsis: true,
// },
{
	title: '库存数量',
	dataIndex: 'storageNum',
	ellipsis: true,
},
{
	title: '单位',
	dataIndex: 'unit',
	ellipsis: true,
},

{
	title: '领用人',
	dataIndex: 'createByName',
	ellipsis: true,
},
{
	title: '领用数量',
	dataIndex: 'amount',
	ellipsis: true,
},
]
const columnsclaim2 = [{
	title: '序号',
	dataIndex: 'index',
	key: 'index',
	scopedSlots: {
		customRender: 'index',
	},
	width: 70,
	ellipsis: true,
},
{
	title: '公司名称',
	dataIndex: 'companyName',
	ellipsis: true,
},
{
	title: '类别',
	dataIndex: 'spuTypeName',
	ellipsis: true,
},
{
	title: '品类编号',
	dataIndex: 'spuSn',
	ellipsis: true,
},
{
	title: '品类名称',
	dataIndex: 'name',
	ellipsis: true,
},
{
	title: '申领时间',
	dataIndex: 'createTime',
	ellipsis: true,
	width: 200,
},
{
	title: '规格型号',
	dataIndex: 'model',
	ellipsis: true,
},
{
	title: '是否已检定',
	dataIndex: 'isInspected',
	key: 'isInspected',
	scopedSlots: {
		customRender: 'isInspected',
	},
	ellipsis: true,
},
{
	title: '采购均价',
	dataIndex: 'price',
	ellipsis: true,
},
{
	title: '领用数量',
	dataIndex: 'amount',
	ellipsis: true,
},
{
	title: '领用人',
	dataIndex: 'createByName',
	ellipsis: true,
},
{
	title: '申领时间',
	dataIndex: 'createTime',
	ellipsis: true,
},
{
	title: '状态',
	dataIndex: 'status',
	key: 'status',
	scopedSlots: {
		customRender: 'status',
	},
	ellipsis: true,
},
// {
// 	title: '物品编码',
// 	dataIndex: 'spuSn',
// 	ellipsis: true,
// },
// {
// 	title: '公司名称',
// 	dataIndex: 'companyName',
// 	ellipsis: true,
// },
// {
// 	title: '资产分类',
// 	dataIndex: 'spuTypeName',
// 	ellipsis: true,
// },
// {
// 	title: '是否已检定',
// 	dataIndex: 'isInspected',
// 	key: 'isInspected',
// 	scopedSlots: {
// 		customRender: 'isInspected',
// 	},
// 	ellipsis: true,
// },
// {
// 	title: '物品名称',
// 	dataIndex: 'name',
// 	ellipsis: true,
// },
// {
// 	title: '规格型号',
// 	dataIndex: 'model',
// 	ellipsis: true,
// },
// {
// 	title: '物品单价',
// 	dataIndex: 'price',
// 	ellipsis: true,
// },
// {
// 	title: '领用人',
// 	dataIndex: 'createByName',
// 	ellipsis: true,
// },
// {
// 	title: '领用数量',
// 	dataIndex: 'amount',
// 	ellipsis: true,
// },
{
	title: '出库人',
	dataIndex: 'approver',
	ellipsis: true,
},
{
	title: '出库时间',
	dataIndex: 'updateTime',
	ellipsis: true,
	width: 200,
}
]
const columnslist = [{
	title: '序号',
	dataIndex: 'index',
	key: 'index',
	scopedSlots: {
		customRender: 'index',
	},
	width: 70,
	ellipsis: true,
},
{
	title: '公司名称',
	dataIndex: 'company_name',
	ellipsis: true,
},
{
	title: '类别',
	dataIndex: 'spu_type_name',
	ellipsis: true,
},
{
	title: '品类编号',
	dataIndex: 'spu_sn',
	ellipsis: true,
},
{
	title: '品类名称',
	dataIndex: 'name',
	ellipsis: true,
},
{
	title: '规格型号',
	dataIndex: 'model',
	ellipsis: true,
},
//  {
// 	title: '物品编码',
// 	dataIndex: 'spu_sn',
// 	ellipsis: true,
// },

// {
// 	title: '资产分类',
// 	dataIndex: 'spu_type_name',
// 	ellipsis: true,
// },
{
	title: '是否已检定',
	dataIndex: 'is_inspected',
	key: 'is_inspected',
	scopedSlots: {
		customRender: 'is_inspected',
	},
	ellipsis: true,
},
// {
// 	title: '物品名称',
// 	dataIndex: 'name',
// 	ellipsis: true,
// },

// {
// 	title: '物品数量',
// 	dataIndex: 'amount',
// 	ellipsis: true,
// },
{
	title: '采购均价',
	dataIndex: 'price',
	ellipsis: true,
},
{
	title: '库存数量',
	dataIndex: 'storage_num',
	ellipsis: true,
},
{
	title: '单位',
	dataIndex: 'unit',
	ellipsis: true,
},
	// {
	// 	title: '保质期(天)',
	// 	dataIndex: 'period',
	// 	ellipsis: true,
	// },
	// {
	// 	title: '库存警戒限值',
	// 	dataIndex: 'short_limit',
	// 	ellipsis: true,
	// },
	// {
	// 	title: '操作',
	// 	key: 'action',
	// 	scopedSlots: {
	// 		customRender: 'action',
	// 	},
	// 	width: 150,
	// },
]
const deptMap = {}
export default {
	data() {
		return {
			spuSn: '',
			name: '',
			companyData: [],
			company_id: undefined,
			asset_sn: '',
			querynum: {
				spuSn: '',
				name: '',
				createByName: '',
			},
			querynum2: {
				name: '',
				spuSn: '',
				createByName: '',
			},
			statusMap: '',
			plainOptions: [],
			selectedRowKeysTab: [],
			selectedRowKeysTabItems: [],
			skuvisible: false,
			claimvisible: false,
			skuSerch: {
				name: '',
				time: [],
				page_size: 10,
				page_num: 1,
				total: 0,
			},
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
				pageSizeOptions: ['10', '20', '30', '40', '50'],
				showLessItems: true,
				showSizeChanger: true,
			},
			pagination2: {
				current: 1,
				pageSize: 10,
				total: 0,
				pageSizeOptions: ['10', '20', '30', '40', '50'],
				showLessItems: true,
				showSizeChanger: true,
			},
			pagination3: {
				current: 1,
				pageSize: 10,
				total: 0,
				pageSizeOptions: ['10', '20', '30', '40', '50'],
				showLessItems: true,
				showSizeChanger: true,
			},
			sku_id: '',
			data: [],
			dataclaim: [],
			dataclaim2: [],
			skudata: [],
			username: '',
			columns,
			columnsclaim,
			columnsclaim2,
			columnslist,
			deptMap,
			operTypeMap: {},
			deptTree: [],
			scroll_y: 150,
			pageSize2: 10,
			current2: 1,
			total2: 0,
			data: [],
			name2: '',
			name: '',
			start_date: '',
			end_date: '',
			detailsrow: {},
			selectedRow: [],
			selectedRowKeys: [],
			companylist: [],
			deptlist: [],
			changevisible: false,
			detailsvisible: false,
			labelCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 5,
				},
			},
			wrapperCol: {
				xs: {
					span: 24,
				},
				sm: {
					span: 16,
				},
			},
			warehouseConsumables: checkPermission('assetmenag:delivery:warehouse'),
			bizListConsumables: checkPermission('biz:claim:list'),
		}
	},
	computed: {
		hasSelected() {
			return this.selectedRowKeys.length > 0
		},
	},
	filters: {
		operTypeFilter(type) {
			return operTypeMap[type].text
		},
		deptFilter(type) {
			return deptMap[type].text
		},
	},
	created() {
		enableParent().then(res => {
			// this.companyList = res.data[0]
			var arry = []
			var array1 = {}
			res.rows.forEach(item => {
				console.log(item, 'item==========================')
				if (item.isCompany == 1) {
					if (arry.length != 0) {
						arry.forEach(item1 => {
							if (item1.deptId != item.deptId) {
								array1 = {
									deptId: item.deptId,
									title: item.deptName
								}
							}
						})
						arry.push(array1)
					} else {
						array1 = {
							deptId: item.deptId,
							title: item.deptName
						}
						arry.push(array1)
					}
				}
			})
			this.companyData = arry
		})
		tree_all().then(res => {
			this.companyList = res.data[0]
			this.companylist.unshift({
				deptId: 0,
				title: '所有公司',
				children: [],
			})

		})
		// get_dept_tree().then((res) => {
		// 	this.companylist = res.data.dept_lis
		// 	this.companylist.unshift({
		// 		dept_id: 0,
		// 		dept_name: '所有公司',
		// 		child_lis: [],
		// 	})
		// })
		get_dict('goodStatus', (res) => {
			this.statusMap = res
		})
		this.username = this.$store.getters.userInfo.userName
		dict({
			pageNum: 1,
			pageSize: 10,
			dictType: 'assets_type',
		}).then((res) => {
			this.assettype = res.rows
			this.assettype.map((d) => {
				this.operTypeMap[d.dictCode] = {
					text: d.dictLabel,
				}
			})
		})
		getDeptListEnable2().then((res) => {
			const data = res.rows
			if (data.length > 0) {
				const min = Math.min(...data.map((m) => m.parentId))
				this.buildtree2(data, this.deptTree, this.$store.getters.userInfo.companyId)
			}
		})
		this.out()
		if (this.bizListConsumables) {
			this.biz()
		}
		this.bizList()
	},
	mounted() {
		this.$nextTick(() => {
			var max_h = $('#content_main_center_scroll').height()
			setTimeout(() => {
				this.scroll_y = max_h - $('.ant-table-header').height() - 80
			}, 1000)
		})
	},
	methods: {
		changge(e) {
			console.log(e, 'e===============================')

		},
		bizList() {
			biz_claim_listByUser({
				page_size: this.pagination3.pageSize,
				page_num: this.pagination3.current,
				name: this.querynum2.name,
				spuSn: this.querynum2.spuSn,
			}).then((res) => {
				this.dataclaim2 = res.rows
				// this.dataclaim2.forEach((item) => {
				// 	item.amount = item.amount / 100
				// 	item.skAmount = item.skAmount / 100
				// 	item.price = item.price / 100
				// })
				const pagination = {
					...this.pagination3
				}
				pagination.total = res.total
				this.pagination3 = pagination
			})
		},
		confirmation() {
			var _this = this
			_this.$confirm({
				title: '是否确认领用?',
				onOk() {
					var list = []
					var idList = []
					let user_info = _this.$store.state.user.info;
					let operator = user_info.userName
					_this.selectedRowKeysTabItems.forEach((item) => {
						list.push({
							spuId: item.spuId,
							amount: item.amount,
							createByName: item.createByName,
							deptId: item.deptId,
							id: item.id,
							operator: item.operator
						})
						idList.push({
							id: item.id
						})
					})
					// skucheckout({
					// 	data: list,
					// }).then(res => {
					// 	if (res.code == 200) {
					biz_claim_update(list).then(res => {
						if (res.code == 200) {
							_this.biz()
							_this.$message.success('领用确认成功')
							_this.selectedRowKeysTab = []
							_this.selectedRowKeysTabItems = []
						} else {
							_this.$message.error(res.msg)
						}
					})
					// } else {
					// 	_this.$message.error(res.msg)
					// }
					// })
				},
				onCancel() {
					_this.$message.error('你点击了取消')
				},
				class: 'test',
			})
		},
		reject() {
			var _this = this
			_this.$confirm({
				title: '是否确认驳回?',
				onOk() {
					var idList = []
					let user_info = _this.$store.state.user.info;
					let operator = user_info.userName
					_this.selectedRowKeysTabItems.forEach((item) => {
						idList.push({
							id: item.id
						})
					})
					biz_claim_updateReject(idList).then(res => {
						if (res.code == 200) {
							_this.biz()
							_this.$message.success('驳回成功')
						} else {
							_this.$message.error(res.msg)
						}
					})
				},
				onCancel() {
					_this.$message.error('你点击了取消')
				},
				class: 'test',
			})
		},
		callback(key) {
			this.out()
			if (this.bizListConsumables) {
				this.biz()
			}
			this.bizList()
			this.selectedRowKeysTab = []
			this.selectedRowKeysTabItems = []
			this.pagination.current = 1
			this.pagination2.current = 1
			this.pagination3.current = 1
		},
		queryall() {
			this.querynum = {}
		},
		queryall2() {
			this.querynum2 = {}
		},
		biz() {
			biz_claim_list({
				page_size: this.pagination2.pageSize,
				page_num: this.pagination2.current,
				spuSn: this.querynum.spuSn,
				name: this.querynum.name,
				createByName: this.querynum.createByName,
			}).then((res) => {
				this.dataclaim = res.rows
				// this.dataclaim.forEach((item) => {
				// 	item.amount = item.amount / 100
				// 	item.skAmount = item.skAmount / 100
				// 	item.price = item.price / 100
				// })
				const pagination = {
					...this.pagination2
				}
				pagination.total = res.total
				this.pagination2 = pagination
			})
		},
		queryclaim() {
			this.biz()
		},
		queryclaim2() {
			this.bizList()
		},
		result() {
			this.spuTypeName = ''
			this.company_id = undefined
			this.name2 = ''
			this.name = ''
			this.spuSn = ''
			this.selectedRowKeysTab = []
			this.selectedRowKeysTabItems = []
			this.out()
		},
		changeTable(pagination) {
			this.pagination.current = pagination.current
			this.pagination.pageSize = pagination.pageSize
			this.out()
		},
		changeTableclaim(pagination) {
			this.pagination2.current = pagination.current
			this.pagination2.pageSize = pagination.pageSize
			this.biz()
		},
		changeTableclaim2(pagination) {
			this.pagination3.current = pagination.current
			this.pagination3.pageSize = pagination.pageSize
			this.bizList()
		},
		changeapplier() {
			this.$forceUpdate()
		},
		leaderid(id) {
			get_users2(id, (res) => {
				this.plainOptions = res
			})
		},
		skuOk() {
			this.skuvisible = false
		},
		outchange(record) {
			if (record.outnumber > record.amount) {
				record.outnumber = record.amount
			}
			if (record.outnumber < 1) {
				record.outnumber = 1
			}
			this.$forceUpdate()
		},
		// serch_sku() {
		// 	this.skuSerch.current = 1
		// 	this.get_sku({
		// 		id: this.sku_id
		// 	})
		// },
		// get_sku(row) {
		// 	this.sku_id = row.id
		// 	this.skuvisible = true
		// 	skuget_list({
		// 		spu_id: row.id,
		// 		name: this.skuSerch.name,
		// 		operation: 2,
		// 		start_date: this.skuSerch.time.length ? this.skuSerch.time[0] : '',
		// 		end_date: this.skuSerch.time.length ? this.skuSerch.time[1] : '',
		// 		page_size: this.skuSerch.page_size,
		// 		page_num: this.skuSerch.page_num,
		// 	}).then((res) => {
		// 		this.skudata = res.data.items
		// 		// this.skudata.forEach(item=>{
		// 		// 	item.amount=item.amount/100
		// 		// })
		// 		const skuSerch = {
		// 			...this.skuSerch
		// 		}
		// 		skuSerch.total = res.data.total
		// 		this.skuSerch = skuSerch
		// 	})
		// },
		//改变分页
		handleTableChange(pagination, filters, sorter) {
			this.skuSerch.current = pagination.current
			this.loading = true
			this.get_sku({
				id: this.sku_id
			})
		},
		addTo(row) {
			console.log(row)
			this.selectedRow.push({
				id: row.id,
				name: row.name,
				model: row.model,
				is_inspected: row.is_inspected,
				amount: row.amount,
				unit: row.unit

			})
		},
		removeTo(idx, row) {
			this.selectedRow.splice(idx, 1)
		},
		moneyOk: debounce(function () {
			var list = []
			var is = 1
			let user_info = this.$store.state.user.info;
			let operator = user_info.userName
			this.selectedRow.forEach((item) => {
				if (!item.applier) {
					is = 0
				}
				list.push({
					spuId: item.id,
					amount: item.outnumber,
					applier: item.applier,
					deptId: item.dept_id,
					operator: operator,
					unit: item.unit
				})
			})
			if (!is) {
				this.$message.error('请填写领用人')
				return
			}
			console.log(list, 'list===============================')
			// skucheckout
			consumablesSkuOut(list)
				.then((res) => {
					if (res.code == 200) {
						this.changevisible = false
						this.$message.success('出库成功')
						this.selectedRow = []
						this.selectedRowKeysTab = []
						this.selectedRowKeysTabItems = []
						this.out()
					} else {
						this.$message.error(res.msg)
					}
				})
				.catch(() => {
					this.$message.error('系统错误，请稍后再试')
				})
		}, 1000, {
			'leading': true,
			'trailing': false
		}),
		claimOk: debounce(function () {
			var list = []
			this.selectedRow.forEach((item) => {
				list.push({
					spuId: item.id,
					skAmount: item.amount,
					amount: item.outnumber,
				})
			})
			biz_claim_save(list)
				.then((res) => {
					if (res.code == 200) {
						this.claimvisible = false
						this.$message.success('领用成功')
						this.selectedRow = []
						this.selectedRowKeysTab = []
						this.selectedRowKeysTabItems = []
						this.out()
					} else {
						this.$message.error(res.msg)
					}
				})
				.catch(() => {
					this.$message.error('系统错误，请稍后再试')
				})
		}, 1000, {
			'leading': true,
			'trailing': false
		}),
		moneyCancel() {
			this.changevisible = false
			this.selectedRow = []
			this.selectedRowKeysTab = []
			this.selectedRowKeysTabItems = []
		},
		claimCancel() {
			this.claimvisible = false
		},
		modification() {
			this.selectedRow = []
			this.plainOptions = []
			this.selectedRowKeysTabItems.forEach((item) => {
				item['outnumber'] = 1
				item['dept_id'] = undefined
				item['applier'] = undefined
			})
			this.selectedRow = this.selectedRowKeysTabItems
			this.changevisible = true
			this.companylist.forEach((item) => {
				if (item.deptId == this.$store.getters.userInfo.companyId) {
					this.deptlist = item.children
				}
			})
		},
		claim() {
			this.selectedRow = []
			this.plainOptions = []
			this.selectedRowKeysTabItems.forEach((item) => {
				item['outnumber'] = 1
				item['dept_id'] = undefined
				item['applier'] = undefined
			})
			this.selectedRow = this.selectedRowKeysTabItems
			this.companylist.forEach((item) => {
				if (item.deptId == this.$store.getters.userInfo.companyId) {
					this.deptlist = item.children
				}
			})
			this.claimvisible = true
		},
		onSelectChange(selectedRowKeys, selectedRows) {
			this.selectedRowKeysTabItems = []
			var arr = JSON.parse(JSON.stringify(selectedRows))
			this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
			console.log(this.selectedRowKeysTabItems)
			this.selectedRowKeysTab = selectedRowKeys
			var obj = {}
			this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function (item, next) {
				obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
				return item
			}, [])
			var newLis = []
			this.selectedRowKeysTab.forEach((key, idx) => {
				this.selectedRowKeysTabItems.forEach((item, index) => {
					if (key == item.id) {
						newLis.push(item)
					}
				})
			})
			this.selectedRowKeysTabItems = newLis
		},
		details(row) {
			this.detailsvisible = true
			this.detailsrow = row
		},
		buildtree2(list, arr, parentId) {
			list.forEach((item) => {
				if (item.parentId === parentId) {
					var child = {
						key: item.deptId,
						value: item.deptId, // value是给modal的select用的，2者属性不一样
						title: item.deptName,
						scopedSlots: {
							title: 'title',
						},
						children: [],
					}
					this.buildtree2(list, child.children, item.deptId)
					if (child.children.length === 0) {
						delete child.children
					}
					arr.push(child)
				}
			})
		},
		query2() {
			this.pagination.current = 1
			this.out()
		},
		onChange(date, dateString) {
			this.start_date = date[0]
			this.end_date = date[1]
		},
		out() {
			// get_cheap_list
			consumablesList({
				pageSize: this.pagination.pageSize,
				pageIndex: this.pagination.current,
				name: this.name,
				spuSn: this.spuSn,
				companyId: this.company_id,
				sortField: 'id',
				sortOrder: 'desc'
				// company_id: this.$store.state.user.info.dept.parentId,
				// value_max: 2000
			}).then((res) => {
				var arry = []
				res.data.list.forEach(item => {
					var a = {}
					a = {
						amount: item.storageNum,
						average_price: item.averagePrice,
						company_id: item.companyId,
						company_name: item.companyName,
						createBy: item.createBy,
						createTime: item.createTime,
						dept_id: item.deptId,
						hazard_type: item.hazardType,
						id: item.id,
						is_inspected: item.isInspected,
						is_inspected_name: item.isInspectedName,
						model: item.model,
						name: item.name,
						notes: item.notes,
						period: item.period,
						price: item.price,
						short_limit: item.shortLimit,
						spu_sn: item.spuSn,
						spu_type: item.spuType,
						spu_type_name: item.spuTypeName,
						storage_cond: item.storageCond,
						storage_num: item.storageNum,
						unit: item.unit,
						updateBy: item.updateBy,
						updateTime: item.updateTime

					}
					arry.push(a)
				})

				this.data = arry
				// this.data.forEach((item) => {
				// 	item.price = item.price / 100
				// 	item.value = item.value / 100
				// 	item.amount = item.amount / 100
				// })
				const pagination = {
					...this.pagination
				}
				pagination.total = res.data.totalCount
				this.pagination = pagination
			})
		},
		showSizeChange2(current, pageSize) {
			this.selectedRowKeys = []
			this.selectedRow = []
			this.pageSize2 = pageSize
			this.current2 = current
			this.out()
		},
		onShowSizeChange2(current, pageSize) {
			this.current2 = current
			this.out()
		},
		detailsOk() {
			this.detailsvisible = false
		},
		detailsCancel() {
			this.detailsvisible = false
		},
	},
}
</script>

<style>
.form_item {
	float: left;
	width: 50%;
	height: 50px;
	margin-bottom: 10px;
}
</style>
